<button class="btn btn-primary mb-1" [disabled]="!isEnabled || !hasPermission" (click)="openServedCategoriesModal()" title="{{ tooltipTitle }}" #button>
    <!-- <span class="element-text">{{ getButtonTitle() }}</span> -->
    <span class="element-text">{{ getButtonTitleTranslateTag() | translate }}</span>
</button>
